// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".c11c679e58c298222ec4bb33f97e2fe54420a05a.chunk.bundle.js";
};